import localDisk from 'src/localDisk';
import {CONFIG} from "src/config";
import API from "src/core/Api";
import {store} from "src/store";

export const authState = {
    state: {
        token: localDisk.read('authToken'),
        userInfo: localDisk.read('authUserInfo'),
        userAccess: localDisk.read('userAccess'),
    },
    mutations: {
        AuthSetToken(state, data) {
            if ( data ) {
                state.token = data
                localDisk.write('authToken', data)
            }
            else {
                localDisk.write('authToken', null)
            }
        },
        SetUserInfo(state, data) {
            if ( data ) {
                state.userInfo = data
                localDisk.write('authUserInfo', data)
            }
            else {
                localDisk.write('authUserInfo', null);
            }
        },
        SetAccess(state, data) {
            if ( data ) {
                state.userAccess = data
                localDisk.write('userAccess', data)
            }
            else {
                localDisk.write('userAccess', null);
            }
        },
        Logout(state, data) {
            localDisk.clearDisk();
        },
    },
    getters: {
        AuthIsLogged: state => {
            return !!state.token;
        },
        AuthGetToken: state => {
            return state.token;
        },
        AuthGetUserInfo: state => {
            if (state.userInfo) {
                return state.userInfo;
            }
            else {
                return {};
            }
        },
        AuthUserAccess: state => {
            if (state.userAccess) {
                return state.userAccess;
            }
            else {
                return {};
            }
        },
    },
    actions: {
        AuthValidateToken: ({commit, getters}, payload) => {

            const token = getters.AuthGetToken;

            if (token) {
                fetch(CONFIG.getWsUrl('auth/check'), {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        'Authorization': 'Bearer '+token,
                    },
                })
                    .then(response => response.json())
                    .then(data => {

                        if (typeof data.status !== 'undefined') {

                            // si el token no es valido, deslogueo
                            if (data.status === 0 || !data.status) {
                                commit('AuthSetToken', false);
                                if (typeof payload.routerGuard === 'function') payload.routerGuard('login');
                            }
                            else {
                                // si es valido, guardo la info y continuo bien
                                let accessObj = {};
                                if (typeof data.a !== 'undefined') {
                                    accessObj = data.a;
                                }
                                commit('SetAccess', accessObj);
                                if (typeof payload.callback === 'function') payload.callback(data.data);
                            }
                        }
                        else {
                            // deslogueo
                            commit('AuthSetToken', false);
                            if (typeof payload.routerGuard === 'function') payload.routerGuard('login');
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        commit('AuthSetToken', false);
                        if (typeof payload.routerGuard === 'function') payload.routerGuard('login');
                    });
            }
        },
        AuthLogout: () => {
            localDisk.clearDisk();
        },
    }
}
